import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducer';

// Check if Redux DevTools Extension is available
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create the store with middleware and Redux DevTools
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export default store;
